module.exports = __webpack_public_path__ + "img/pos.b5649a92.png";